import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useIMask } from 'react-imask';
import { useCallback, useEffect, useState } from 'react';
var getValidValue = function getValidValue(value, min, max) {
  return Math.max(min, Math.min(value, max));
};
var ignoredKeys = ['e', '-', '+'];
export var useStepperInput = function useStepperInput(params) {
  var _params$max = params.max,
    max = _params$max === void 0 ? 99 : _params$max,
    _params$min = params.min,
    min = _params$min === void 0 ? 0 : _params$min,
    onBlurProp = params.onBlur,
    onKeyDownProp = params.onKeyDown,
    onChange = params.onChange,
    value = params.value;
  var _useState = useState(value !== null && value !== void 0 ? value : 1),
    _useState2 = _slicedToArray(_useState, 2),
    tempValue = _useState2[0],
    setTempValue = _useState2[1];
  var onAccept = useCallback(function (val) {
    return setTempValue(/^\d+$/.test(val) ? Number(val) : min);
  }, []);
  var _useIMask = useIMask({
      mask: Number,
      scale: 2,
      thousandsSeparator: '',
      padFractionalZeros: false,
      normalizeZeros: true,
      radix: ',',
      mapToRadix: ['.'],
      signed: false,
      min: 0,
      max: 99,
      autofix: true
    }, {
      onAccept: onAccept
    }),
    ref = _useIMask.ref,
    maskRef = _useIMask.maskRef;
  var updateMaskValue = function updateMaskValue(val) {
    maskRef.current.value = val.toString();
    maskRef.current.updateValue();
  };
  useEffect(function () {
    if (!maskRef.current) {
      return;
    }
    var validValue = typeof value === 'number' ? getValidValue(value, min, max) : '';
    updateMaskValue(validValue);
    if (typeof validValue === 'number') {
      setTempValue(validValue);
    }
  }, [value, min, max]);
  var onBlur = function onBlur(e) {
    var newValue = getValidValue(Number(e.target.value || 1), min, max);
    updateMaskValue(newValue);
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue, e);
    onBlurProp === null || onBlurProp === void 0 ? void 0 : onBlurProp(e);
  };
  var onKeyDown = function onKeyDown(e) {
    onKeyDownProp === null || onKeyDownProp === void 0 ? void 0 : onKeyDownProp(e);
    if (e.key === 'Enter') {
      var newValue = getValidValue(Number(maskRef.current.unmaskedValue || 1), min, max);
      updateMaskValue(newValue);
      onChange === null || onChange === void 0 ? void 0 : onChange(newValue, e);
      return;
    }
    var isUnlimited = e.key === 'ArrowUp' && Number(maskRef.current.unmaskedValue || 1) + 1 > max;
    if (ignoredKeys.includes(e.key) || isUnlimited) {
      e.preventDefault();
    }
  };
  return {
    inputRef: ref,
    inputProps: {
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      min: min,
      max: max
    },
    tempValue: tempValue
  };
};